"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModalForm = exports.ModalForm = void 0;
var tslib_1 = require("tslib");
var ModalForm_1 = require("@reactionable/core/lib/ui/modal/ModalForm");
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
var Modal_1 = tslib_1.__importDefault(require("react-bootstrap/Modal"));
var react_i18next_1 = require("react-i18next");
var Form_1 = require("../form/Form");
function ModalForm(_a) {
    var submitButton = _a.submitButton, cancelButton = _a.cancelButton, closeModal = _a.closeModal, children = _a.children, formProps = tslib_1.__rest(_a, ["submitButton", "cancelButton", "closeModal", "children"]);
    var t = react_i18next_1.useTranslation().t;
    var renderFormChildren = function (formikProps) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Modal_1.default.Body, null, children(formikProps)),
            react_1.default.createElement(Modal_1.default.Footer, null,
                react_1.default.createElement(Button_1.default, { disabled: formikProps.isSubmitting, onClick: closeModal, variant: "secondary" }, cancelButton ? cancelButton : t('Cancel')),
                react_1.default.createElement(Form_1.SubmitButton, tslib_1.__assign({}, {
                    disabled: formikProps.isSubmitting,
                    children: typeof submitButton === 'string' ? submitButton : undefined,
                })))));
    };
    return react_1.default.createElement(Form_1.Form, tslib_1.__assign({}, formProps, { children: renderFormChildren }));
}
exports.ModalForm = ModalForm;
function useModalForm(props) {
    return ModalForm_1.useModalForm(tslib_1.__assign(tslib_1.__assign({}, props), { FormComponent: ModalForm }));
}
exports.useModalForm = useModalForm;
//# sourceMappingURL=ModalForm.js.map